// @flow

import React, { type Node, useState } from 'react';
import { useEventBusListener } from '@tectonics/public-event-bus';
import { useSendPendingEvent } from '@tectonics/analytics';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { StatusMessage } from './status-message';
import { IofDisplay } from '../commons/iof/components';

export function PendingPageContent(): Node {
  const features = useAllFeatures();
  const [isReady, setReady] = useState<bool>(false);

  useEventBusListener('bromelia:step:thank_you', () => {
    setReady(true);
  });

  useSendPendingEvent(isReady);

  return (
    <>
      <IfFeature allFeatures={features} wanted="display_receipt_brazilian_tax_iof">
        <IofDisplay />
      </IfFeature>

      <StatusMessage />
    </>
  );
}
